<template>
  <div>
    <el-button :loading="handleSaveLoading" style="float: right;margin-right: 5px;" @click="handleSave()" icon='el-icon-edit' size='mini' type="primary">保存</el-button>
    <span style="color: red;font-size: 12px;float:right;line-height: 30px;margin-right: 20px;">* 点击表格进行编辑</span>
    <h3>主要联系人员</h3>
    <el-table-edit :model="dataList" :columns="['position','name','tel','emailaddress']" ref="editTable">
      <el-table :data="dataList" size="small" stripe style="width: 100%;" @selection-change="selectionChangeHandle" ref="table" :row-class-name="rowClassName" @row-dblclick="editAll">
        <el-table-column type="selection" fixed="left"></el-table-column>
        <el-table-column label="序号" header-align="center" align="center" width="50" prop="index">
          <template slot-scope="scope">
            {{ scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column prop="position" label="职位" align="center" header-align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.position === '业务联系人' 
            || scope.row.position === '销售副总' 
            || scope.row.position === '技术最高决策人' || scope.row.position === '质量最高决策人'" style="color: red;">*</span>
            <span>{{scope.row.position}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="name" label="姓名" align="center" header-align="center">
          <template slot-scope="scope">
            <el-input v-if="scope.row.show" v-model="scope.row.name" placeholder="姓名"></el-input>
            <span v-else>{{scope.row.name}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="tel" label="电话" align="center" header-align="center">
          <template slot-scope="scope">
            <el-input type="number" v-if="scope.row.show" v-model="scope.row.tel" placeholder="电话"></el-input>
            <span v-else>{{scope.row.tel}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="email" label="E-mail" header-align="center" align="center">
          <template slot-scope="scope">
            <el-input type="email" v-if="scope.row.show" v-model="scope.row.email" placeholder="E-mail"></el-input>
            <span v-else>{{scope.row.email}}</span>
          </template>
        </el-table-column>
      </el-table>
    </el-table-edit>
    <el-pagination
      @size-change="sizeChangeHandle"
      @current-change="currentChangeHandle"
      :current-page="pageIndex"
      :page-sizes="[10,15,20]"
      :page-size="pageSize"
      :total="totalPage"
      layout="total, sizes, prev, pager, next, jumper">
    </el-pagination>
  </div>
</template>

<script>
import Vue from 'vue'
import { saveSupplierContacts, listSupplierContracts, listInvitedForSupplier } from '@/controller/portal'
export default {
  computed: {
    editTable() {
      return this.$refs.editTable
    }
  },
  data () {
    return {
      handleSaveLoading:false,
      show:false,
      totalPage: 0,
      pageIndex:1,
      pageSize:15,
      dataForm: {
        key: ''
      },
      dataListLoading: false,
      editRowslist: [],
      dataList: [
        { position: '业务联系人', value: '1', name: '', tel: '', email: '', id: null },
        { position: '销售副总', value: '2', name: '', tel: '', email: '', id: null },
        { position: '技术最高决策人', value: '3', name: '', tel: '', email: '', id: null },
        { position: '质量最高决策人', value: '4', name: '', tel: '', email: '', id: null },
        { position: '法定代表人', value: '5', name: '', tel: '', email: '', id: null },
        { position: '企业负责人', value: '6', name: '', tel: '', email: '', id: null },
        { position: '销售负责人', value: '7', name: '', tel: '', email: '', id: null },
        { position: '质量负责人', value: '8', name: '', tel: '', email: '', id: null },
        { position: '业务联系人2', value: '9', name: '', tel: '', email: '', id: null },
        { position: '业务联系人3', value: '10', name: '', tel: '', email: '', id: null },
      ],
      position: '',
      name: '',
      tel: '',
      email: '',
      venderInviteFid: '',
      // applyStatus: '',
      dataListSelections: []
    }
  },
  props: {
    superId: Number
  },
  mounted() {
    this.getList()
  },
  watch: {
    venderInviteFid() {
      this.getDataList()
    }
  },
  methods: {
    // 每页数
    sizeChangeHandle (val) {
      this.pageSize = val
      this.pageIndex = 1
      this.getDataList()
    },
    // 当前页
    currentChangeHandle (val) {
      this.pageIndex = val
      this.getDataList()
    },
    handleNewRows() {
      this.dataList.push({
        // edit: true,
      })
    },
    deletefront(row) {
      this.dataList.splice(row,1);
    },
    editAll() {
      debugger
      let data = JSON.parse(JSON.stringify(this.dataList ? this.dataList : []));
      data.forEach((element) => {
        element["show"] = true;
      });
      this.dataList = data;
    },
    handleSave() {
      //校验必填：共8条、前4条必填
      for(var i=0; i<4;i++){
        let msg = this.dataList[i].position;
        //校验必填
        if(!this.dataList[i].name){
          this.$message.error(msg + "的姓名，不可为空")
          return
        }
        if(!this.dataList[i].tel){
          this.$message.error(msg + "的电话，不可为空")
          return
        }
        if(!this.dataList[i].email){
          this.$message.error(msg + "的邮箱，不可为空")
          return
        }
      }
      this.saveData(this.dataList)
    },
    saveData(list) {
      this.handleSaveLoading = true
      saveSupplierContacts({
          'contactList' : list,
          'inviteId': this.superId
      }).then(data => {
        if (data && data.code === '00') {
          this.$message({
            message: '操作成功',
            type: 'success',
          })
          this.getDataList()
          this.handleSaveLoading = false
        } else {
          this.handleSaveLoading = false
          this.$message.error(data.msg)
        }
      }).catch((e) => {
        this.handleSaveLoading = false
      })
    },
    getDataList() {
      listSupplierContracts({
          'pageNo': this.pageIndex,
          'pageSize': this.pageSize,
          'inviteId' : this.superId
      }).then(data => {
         if (data && data.code === '00') {
          if (data.body.records.length > 0){
            // 补充默认赋值的8条数据
            for (let i=0;i<this.dataList.length;i++) {
              for (let j=0;j<data.body.records.length;j++) {
                if (this.dataList[i].position === data.body.records[j].position) {
                  this.dataList[i].id = data.body.records[j].id;
                  this.dataList[i].name = data.body.records[j].name;
                  this.dataList[i].tel = data.body.records[j].tel;
                  this.dataList[i].email = data.body.records[j].email;
                  break;
                }
              }
            }
            this.totalPage = data.body.total
          }
        } else {
          this.totalPage = 0
        }
        this.dataListLoading = false
      })
    },
    // 多选
    selectionChangeHandle(val) {
      this.dataListSelections = val
    },
    rowClassName({
      row,
      rowIndex
    }) {
      row.rowid = rowIndex + 1;
    },
    getList() {
      listInvitedForSupplier().then(data => {
        this.venderInviteFid = data.body.records[0].id
      })
    },
  }
}
</script>
